//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import types from './type';
export default {
  name: 'ExceptionPage',
  props: {
    type: {
      type: String,
      default: '404'
    }
  },
  data: function data() {
    return {
      config: types
    };
  },
  methods: {
    handleToHome: function handleToHome() {}
  }
};